// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"7953e518","243":"9f65aea5","253":"eba6ac8a","417":"76212509","453":"0180b362","615":"2ad28f60","692":"bb1b0f24","794":"3f0e02a1","815":"e02d17bb","933":"3486d738","947":"6aac26cd"}[chunkId] + ".chunk.js";
};